
import React, { useEffect, useState } from 'react';
import { useMyContext } from '../../../context/MyContext';
import NavBar from '../../../component/b2c/navBar/navBar';
import Sidebar from '../../../component/b2c/sidebar/sidebar';
import { FiDownload } from "react-icons/fi";
import { Base_Url, ratecsvuplode, fetchUser, ratecardList } from '../../../config/config'
import { toast } from 'react-toastify';
import { Upload, X, Eye } from 'lucide-react';
import { FileText, Sparkles, CheckCircle } from 'lucide-react';
import axios from 'axios';
import '../../../css/custom-scrollbar.css';
import Select from "react-dropdown-select";
import Papa from "papaparse";
import { useNavigate } from 'react-router-dom';

export default function SetRate() {
  const [file, setFile] = useState(null);
  const [Id, setId] = useState('')
  const [isUploading, setIsUploading] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  const [customers, setCustomers] = useState([]);
  const [previewData, setPreviewData] = useState(null);
  const [isPreviewModalOpen, setIsPreviewModalOpen] = useState(false);
  const [uploadSuccess, setUploadSuccess] = useState(false);
  const { isDarkMode, isToggleSidebar } = useMyContext();
  const token = localStorage.getItem('token');
  const cus_id = localStorage.getItem('cus_id');
  const navigate = useNavigate()

  useEffect(() => {
    fetchCustomers();
  }, [])

  const handleFileChange = (e) => {
    const uploadedFile = e.target.files[0];
    setFile(uploadedFile);
    setUploadSuccess(false);

    // Parse CSV for preview
    Papa.parse(uploadedFile, {
      complete: (results) => {
        setPreviewData(results.data);
      },
      header: true,
      skipEmptyLines: true,
    });
  };


  const handleUpload = async (event) => {
    event.preventDefault();
    if (!Id) {
      toast.error('Please select a seller first.');
      return;
    }
    const token = localStorage.getItem('token');
    const cus_id = localStorage.getItem('cus_id');
    setIsUploading(true);
    if (file) {
      const formData = new FormData();
      formData.append('csv_file', file);
      formData.append('seller_id', Id)
      try {
        const response = await axios.post(Base_Url + "admin/" + ratecsvuplode, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'token': token,
            'cus_id': cus_id,
          },
        });
        setFile(null);
        if (response.data.status === "success") {
          toast.success(response.data.message);
          setIsUploading(false);
          setUploadSuccess(true);
          setTimeout(() => {
            navigate("/dasboard");
          }, 1000)
        }
        else if (response.data.status === "success") {
          toast.error(response.data.message + response.data.message);
        }
        else {
          toast.error(response.data.message + response.data.message);
          setIsUploading(false);
        }
      } catch (error) {
        setIsUploading(false);
      }
    }
  };

  const fetchRateCardList = async (selectedId) => {
    try {
      const url = Base_Url + ratecardList + "/" + selectedId;

      const response = await fetch(url, {
        method: 'GET',
        headers: {
          token: token || '',
          cus_id: cus_id || '',
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to fetch data');
      }

      const result = await response.json();

      if (result && result.data) {
        return result.data;
      } else {
        console.error('Unexpected response structure:', result);
        throw new Error('Unexpected response structure');
      }
    } catch (error) {
      console.error('API error:', error.message);
      toast.error('Error fetching rate card data: ' + error.message);
      throw error;
    }
  };

  const handleDownloadRateCard = async () => {
    if (!Id) {
      toast.error('Please select an ID first.');
      return;
    }

    setIsDownloading(true);
    try {
      const rateCardData = await fetchRateCardList(Id);

      if (rateCardData && rateCardData.length > 0) {
        // Convert data to CSV format
        const csvContent = Papa.unparse(rateCardData, {
          header: true,
          columns: [
            'zone_name',
            'surface_price',
            'additional_surfaceprice_per500gm',
            'express_price',
            'additional_expressprice_per500gm',
            'partner',
            'min_cod_price',
            'cod_percentage'
          ]
        });

        // Create and download CSV file
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', `ratecard_${Id}_${new Date().toISOString().split('T')[0]}.csv`);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        toast.success('Rate card downloaded successfully!');
      } else {
        toast.error('No rate card data found for this ID.');
      }
    } catch (error) {
      toast.error('Failed to download rate card: ' + error.message);
    } finally {
      setIsDownloading(false);
    }
  };

  const openPreviewModal = () => {
    setIsPreviewModalOpen(true);
  };
  const closePreviewModal = () => {
    setIsPreviewModalOpen(false);
  };

  const fetchCustomers = async () => {
    const url = Base_Url + fetchUser;
    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          token: token,
          cus_id: cus_id,
          'Content-Type': 'application/json'
        }
      });
      const data = await response.json();
      if (data.status === "success") {
        const transformedData = data.data.map(user => {
          const capitalizedName = user.name.charAt(0).toUpperCase() + user.name.slice(1);
          return {
            value: user.id,
            label: `${capitalizedName} (${user.id})`,
          };
        });
        setCustomers(transformedData);
      } else {
        toast.error(`Error: ${data.message} (Code: ${data.code})`);
      }
    } catch (error) {
      toast.error(`Error: ${error.message}`);
    }
  }
  const handleSelectChange = (selected) => {
    if (selected.length > 0) {
      const selectedItem = selected[0];
      setId(selectedItem.value);
    }
  };

  const PreviewModal = () => {
    if (!previewData || previewData.length === 0) return null;

    // Get column headers
    const headers = Object.keys(previewData[0]);

    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm overflow-y-auto">
        <div className={`bg-white/95 dark:bg-slate-900/95 backdrop-blur-xl rounded-3xl shadow-2xl w-11/12 max-w-6xl max-h-[90vh] overflow-hidden border border-white/20 dark:border-white/10 transform animate-in fade-in-0 zoom-in-95 duration-300`}>

          {/* Enhanced Header with Gradient */}
          <div className="flex justify-between items-center p-6 border-b border-gray-200/50 dark:border-gray-700/50 bg-gradient-to-r from-purple-600 to-pink-600 relative overflow-hidden">
            {/* Animated Background Elements */}
            <div className="absolute inset-0 bg-gradient-to-r from-purple-600/80 via-pink-600/80 to-indigo-600/80" style={{
              animation: 'gradient-x 15s ease infinite'
            }}></div>

            <div className="flex items-center space-x-3 relative z-10">
              <div className="p-2 bg-white/20 rounded-full backdrop-blur-sm animate-pulse">
                <FileText className="w-6 h-6 text-white" />
              </div>
              <div>
                <h2 className="text-2xl font-bold text-white bg-gradient-to-r from-white to-purple-100 bg-clip-text text-transparent">
                  Data Preview
                </h2>
                <p className="text-purple-100 text-sm">Review your uploaded data</p>
              </div>
              <Sparkles className="w-5 h-5 text-yellow-300 animate-pulse" />
            </div>

            <button
              onClick={closePreviewModal}
              className="p-2 bg-white/20 hover:bg-white/30 rounded-full transition-all duration-200 text-white hover:scale-110 transform relative z-10"
            >
              <X className="h-6 w-6" />
            </button>

            {/* Floating Elements */}
            <div className="absolute top-2 right-16" style={{ animation: 'float 3s ease-in-out infinite' }}>
              <div className="w-2 h-2 bg-white/30 rounded-full"></div>
            </div>
            <div className="absolute top-6 right-20" style={{ animation: 'float 3s ease-in-out infinite', animationDelay: '300ms' }}>
              <div className="w-1.5 h-1.5 bg-white/40 rounded-full"></div>
            </div>
          </div>

          {/* Enhanced Content Area */}
          <div className="overflow-auto max-h-[70vh] p-4 custom-scrollbar bg-gradient-to-br from-gray-50/50 to-white/50 dark:from-slate-800/50 dark:to-slate-900/50">

            {/* Data Stats Card */}
            <div className="mb-4 bg-gradient-to-r from-blue-50 to-indigo-50 dark:from-blue-900/20 dark:to-indigo-900/20 rounded-xl p-4 border border-blue-200/50 dark:border-blue-800/50 backdrop-blur-sm">
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-3">
                  <div className="p-2 bg-gradient-to-r from-blue-500 to-indigo-500 rounded-full">
                    <FileText className="w-4 h-4 text-white" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-800 dark:text-gray-200 text-sm">Data Summary</h3>
                    <p className="text-xs text-gray-600 dark:text-gray-400">
                      Total Records: <span className="font-bold text-blue-600 dark:text-blue-400">{previewData.length}</span> |
                      Columns: <span className="font-bold text-blue-600 dark:text-blue-400">{headers.length}</span>
                    </p>
                  </div>
                </div>
                <div className="text-right">
                  <p className="text-xs text-gray-500 dark:text-gray-400">Showing first 50 rows</p>
                </div>
              </div>
            </div>

            {/* Enhanced Table */}
            <div className="rounded-2xl overflow-hidden border border-gray-200/50 dark:border-gray-700/50 shadow-lg backdrop-blur-sm bg-white/80 dark:bg-slate-800/80">
              <div className="overflow-x-auto custom-scrollbar">
                <table className="w-full">

                  {/* Enhanced Header */}
                  <thead className="sticky top-0 bg-gradient-to-r from-indigo-500 to-purple-600 backdrop-blur-sm">
                    <tr>
                      {headers.map((header, index) => (
                        <th
                          key={index}
                          className="p-4 text-left font-semibold text-white text-sm uppercase tracking-wide border-r border-white/20 last:border-r-0 relative group"
                        >
                          <div className="flex items-center space-x-2">
                            <span>{header}</span>
                            <div className="w-1 h-1 bg-white/40 rounded-full opacity-0 group-hover:opacity-100 transition-opacity"></div>
                          </div>
                        </th>
                      ))}
                    </tr>
                  </thead>

                  {/* Enhanced Body */}
                  <tbody>
                    {previewData.slice(0, 50).map((row, rowIndex) => (
                      <tr
                        key={rowIndex}
                        className={`${rowIndex % 2 === 0
                          ? 'bg-gray-50/50 dark:bg-gray-800/30'
                          : 'bg-white/50 dark:bg-gray-700/30'
                          } hover:bg-blue-50/70 dark:hover:bg-blue-900/20 transition-all duration-200 hover:scale-[1.005] transform`}
                      >
                        {headers.map((header, colIndex) => (
                          <td
                            key={colIndex}
                            className="p-4 text-sm text-gray-700 dark:text-gray-300 border-r border-gray-200/50 dark:border-gray-600/50 last:border-r-0 hover:bg-blue-50/30 dark:hover:bg-blue-900/10 transition-colors duration-150"
                          >
                            <div className="truncate max-w-xs" title={row[header]}>
                              {row[header]}
                            </div>
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <style jsx>{`
    @keyframes gradient-x {
      0%, 100% {
        transform: translateX(0%);
      }
      50% {
        transform: translateX(100%);
      }
    }
    
    @keyframes float {
      0%, 100% {
        transform: translateY(0px);
      }
      50% {
        transform: translateY(-10px);
      }
    }
    
    .custom-scrollbar {
      scrollbar-width: thin;
      scrollbar-color: rgba(139, 92, 246, 0.5) transparent;
    }
    
    .custom-scrollbar::-webkit-scrollbar {
      width: 6px;
      height: 6px;
    }
    
    .custom-scrollbar::-webkit-scrollbar-track {
      background: transparent;
    }
    
    .custom-scrollbar::-webkit-scrollbar-thumb {
      background: rgba(139, 92, 246, 0.5);
      border-radius: 3px;
    }
    
    .custom-scrollbar::-webkit-scrollbar-thumb:hover {
      background: rgba(139, 92, 246, 0.7);
    }
  `}</style>
      </div>
    );
  };

  return (
    // <div className={`h-screen flex flex-col overflow-hidden ${isDarkMode ? 'dark:bg-gradient-to-br dark:from-slate-900 dark:via-purple-900 dark:to-slate-900' : 'bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50'}`}>
        <div className={`h-screen flex flex-col overflow-hidden ${isDarkMode ? 'dark:bg-darkmodeColor' : 'bg-white'}`}>
      {isPreviewModalOpen && <PreviewModal />}

      {/* Animated Background Elements */}
      <div className="fixed inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-1/4 left-1/4 w-64 h-64 bg-purple-500/10 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-blue-500/10 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1000ms' }}></div>
        <div className="absolute top-1/2 left-1/2 w-32 h-32 bg-pink-500/10 rounded-full blur-2xl animate-bounce" style={{ animationDelay: '500ms' }}></div>
      </div>

      <div className="z-10">
        <NavBar />
      </div>

      <div className="flex flex-1 overflow-hidden">
        {isToggleSidebar && (
          <div
 className={`fixed z-20 h-full w-64 md:relative duration-300 bg-gray-200 dark:bg-darkmodeColor dark:text-white md:bg-transparent mt-4 md:w-64 md:z-20`}
            style={
              window.innerWidth < 768
                ? { top: '113px', height: 'calc(100vh - 115px)', overflowY: 'auto' }
                : {}
            }
          >
            <Sidebar />
          </div>
        )}

        <div className='backdrop-blur-xl custom-scrollbar bg-white/10 overflow-y-auto dark:bg-darkmodeColorborder border-white/20 dark:border-white/10 rounded-3xl w-full mt-6 mb-3 mr-3 ml-3 shadow-2xl'>
          <div className={`p-2 md:p-3 min-h-[30vh] overflow-y-auto ${isToggleSidebar ? 'ml-0' : 'mr-0'} ${isToggleSidebar ? 'w-full' : 'w-full'} mb-4 md:mb-0`}>
            <div className="max-w-4xl mx-auto">
              <div className="backdrop-blur-xl bg-white/10 dark:bg-darkmodeColorborder border-white/20 dark:border-white/10 rounded-3xl overflow-hidden shadow-2xl transform hover:scale-[1.02] transition-all duration-500">

                {/* Header with Gradient and Animation */}
                <div className="bg-gradient-to-r from-customPurple via-customPurple to-customPurple p-1.5 text-white rounded-t-3xl relative overflow-hidden">
                  <div className="absolute inset-0 bg-gradient-to-r from-purple-600/80 via-pink-customPurple to-blue-600/80" style={{
                    animation: 'gradient-x 15s ease infinite'
                  }}></div>
                  <div className="relative z-10">
                    <div className="flex items-center space-x-2 mb-1">
                      <div className="p-2 bg-white/20 rounded-full backdrop-blur-sm animate-pulse">
                        <Upload className="w-3 h-3" />
                      </div>
                      <h2 className="text-xs font-bold bg-gradient-to-r from-white to-purple-100 bg-clip-text text-transparent">
                        Upload Rate Card
                      </h2>
                      <Sparkles className="w-4 h-4 text-yellow-300 animate-pulse" />
                    </div>
                    <p className="text-purple-100 text-xs ml-5">Transform your data with intelligent CSV processing</p>
                  </div>

                  {/* Floating Elements */}
                  <div className="absolute top-2 right-2" style={{ animation: 'float 3s ease-in-out infinite' }}>
                    <div className="w-2 h-2 bg-white/30 rounded-full"></div>
                  </div>
                  <div className="absolute top-6 right-6" style={{ animation: 'float 3s ease-in-out infinite', animationDelay: '300ms' }}>
                    <div className="w-1.5 h-1.5 bg-white/40 rounded-full"></div>
                  </div>
                  <div className="absolute top-4 right-10" style={{ animation: 'float 3s ease-in-out infinite', animationDelay: '700ms' }}>
                    <div className="w-2.5 h-2.5 bg-white/20 rounded-full"></div>
                  </div>
                </div>

                {/* Customer Selection with Enhanced Styling */}
                <div className='mt-3 mx-4'>
                  <label htmlFor="Id" className="block text-xs font-semibold text-gray-700 dark:text-gray-200 mb-2 flex items-center">
                    <div className="w-1.5 h-1.5 bg-gradient-to-r from-purple-500 to-customPurple rounded-full mr-2 animate-pulse"></div>
                    Select Customer ID
                  </label>
                  <div className="relative group rounded-full shadow-custom-light dark:shadow-custom-dark">
                    <Select
                      options={customers}
                      onChange={handleSelectChange}
                      className="w-full"
                      styles={{
                        control: (base) => ({
                          ...base,
                          padding: '4px',
                          background: isDarkMode ? 'rgba(30, 41, 59, 0.8)' : 'rgba(255, 255, 255, 0.8)',
                          backdropFilter: 'blur(12px)',
                          border: '2px solid transparent',
                          borderRadius: '12px',
                          fontSize: '12px',
                          fontWeight: '500',
                          boxShadow: '0 15px 30px -8px rgba(0, 0, 0, 0.25)',
                          '&:hover': {
                            transform: 'scale(1.02)',
                            boxShadow: '0 15px 30px -8px rgba(0, 0, 0, 0.4)'
                          }
                        }),
                        option: (base, state) => ({
                          ...base,
                          backgroundColor: state.isSelected
                            ? 'linear-gradient(to right, #8b5cf6, #ec4899)'
                            : state.isFocused
                              ? isDarkMode ? 'rgba(139, 92, 246, 0.2)' : 'rgba(139, 92, 246, 0.1)'
                              : 'transparent',
                          color: isDarkMode ? 'white' : '#1e293b'
                        })
                      }}
                    />
                  </div>
                </div>

                {/* Download Button with Animation */}
                <div className="mt-3 mx-4">
                  <button
                    type="button"
                    onClick={handleDownloadRateCard}
                    disabled={!Id || isDownloading}
                    className={`group w-full p-2.5 rounded-xl font-semibold text-xs transition-all duration-500 transform hover:scale-[1.02] shadow-lg hover:shadow-xl ${!Id || isDownloading
                      ? 'bg-gray-300 dark:bg-gray-600 cursor-not-allowed text-gray-500'
                      : 'bg-gradient-to-r from-green-500 to-emerald-600 hover:from-green-600 hover:to-emerald-700 text-white'
                      }`}
                  >
                    <div className="flex items-center justify-center space-x-2">
                      {isDownloading ? (
                        <div className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin"></div>
                      ) : (
                        <FiDownload className="w-4 h-4 group-hover:animate-bounce" />
                      )}
                      <span>{isDownloading ? 'Downloading Magic...' : 'Download Current Rate Card'}</span>
                      {!isDownloading && <Sparkles className="w-4 h-4 opacity-70 group-hover:opacity-100 transition-opacity" />}
                    </div>
                  </button>
                </div>

                {/* File Upload Section with Drag & Drop */}
                <div className="p-4">
                  <div className="mb-4">
                    <label className="block text-xs font-semibold text-gray-700 dark:text-gray-200 mb-2 flex items-center">
                      <div className="w-1.5 h-1.5 bg-gradient-to-r from-blue-500 to-purple-500 rounded-full mr-2 animate-pulse"></div>
                      Upload Your CSV File
                    </label>

                    {/* Drag & Drop Zone */}
                    <div
                      className="relative border-2 border-dashed rounded-2xl p-4 transition-all duration-300
                         backdrop-blur-xl bg-white/30 dark:bg-darkmodeColorhover:bg-white/40 dark:hover:bg-black/30 group cursor-pointer"
                    >
                      <input
                        type="file"
                        accept=".csv"
                        onChange={handleFileChange}
                        className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                      />

                      <div className="text-center">
                        <div className="mx-auto w-10 h-10 bg-customPurple rounded-full flex items-center justify-center mb-2 group-hover:scale-110 transition-transform duration-300">
                          <Upload className="w-5 h-5 text-white animate-bounce" />
                        </div>
                        <p className="text-xs font-semibold text-gray-700 dark:text-gray-200 mb-1">
                          Drop your CSV file here or click to browse
                        </p>
                        <p className="text-xs text-gray-500 dark:text-gray-400">
                          Supports CSV files up to 10MB
                        </p>

                        {file && (
                          <div className="mt-2 p-2 bg-gradient-to-r from-green-100 to-emerald-100 dark:from-green-900/30 dark:to-emerald-900/30 rounded-xl border border-green-200 dark:border-green-800">
                            <div className="flex items-center justify-center space-x-2">
                              <CheckCircle className="w-4 h-4 text-green-600 animate-pulse" />
                              <span className="font-medium text-xs text-green-800 dark:text-green-200">{file.name}</span>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>

                    {/* Action Buttons */}
                    <div className="flex flex-col md:flex-row gap-2 mt-3">
                      <button
                        type="button"
                        onClick={handleUpload}
                        disabled={!file || isUploading}
                        className={`group flex-1 p-2.5 rounded-xl font-semibold text-xs transition-all duration-500 transform hover:scale-[1.02] shadow-lg hover:shadow-xl ${!file || isUploading
                          ? 'bg-gray-300 dark:bg-gray-600 cursor-not-allowed text-gray-500'
                          : 'bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white'
                          }`}
                      >
                        <div className="flex items-center justify-center space-x-2">
                          {isUploading ? (
                            <div className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin"></div>
                          ) : (
                            <Upload className="w-4 h-4 group-hover:animate-bounce" />
                          )}
                          <span>{isUploading ? 'Processing...' : 'Upload & Process'}</span>
                          {!isUploading && <Sparkles className="w-4 h-4 opacity-70 group-hover:opacity-100 transition-opacity" />}
                        </div>
                      </button>

                      {file && previewData && (
                        <button
                          type="button"
                          onClick={openPreviewModal}
                          className="group flex-1 md:flex-none md:px-4 p-2.5 rounded-xl font-semibold text-xs bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 text-white transition-all duration-500 transform hover:scale-[1.02] shadow-lg hover:shadow-xl"
                        >
                          <div className="flex items-center justify-center space-x-2">
                            <Eye className="w-4 h-4 group-hover:animate-pulse" />
                            <span>Preview Data</span>
                          </div>
                        </button>
                      )}
                    </div>
                  </div>
                </div>

                {/* Enhanced Template Download */}
                <div className="mx-4 mb-4">
                  <div className="bg-gradient-to-r from-indigo-50 to-purple-50 dark:from-indigo-900/20 dark:to-purple-900/20 rounded-xl p-3 border border-indigo-200 dark:border-indigo-800">
                    <div className="flex items-center justify-between">
                      <div className="flex items-center space-x-3">
                        <div className="p-2 bg-gradient-to-r from-indigo-500 to-purple-500 rounded-full">
                          <FileText className="w-4 h-4 text-white" />
                        </div>
                        <div>
                          <h3 className="font-semibold text-gray-800 dark:text-gray-200 text-xs">Need a template?</h3>
                          <p className="text-xs text-gray-600 dark:text-gray-400">Download our pre-formatted CSV template</p>
                        </div>
                      </div>
                      <a
                        href="/sampleFile/ratecard 5.csv"
                        download="ratecard.csv"
                        className="group px-3 py-2 bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 text-white rounded-xl font-semibold text-xs transition-all duration-300 transform hover:scale-105 shadow-md hover:shadow-lg flex items-center space-x-1.5"
                      >
                        <FiDownload className="w-4 h-4 group-hover:animate-bounce" />
                        <span>Download Template</span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
       @keyframes gradient-x {
         0%, 100% {
           transform: translateX(0%);
         }
         50% {
           transform: translateX(100%);
         }
       }
       
       @keyframes float {
         0%, 100% {
           transform: translateY(0px);
         }
         50% {
           transform: translateY(-10px);
         }
       }
       
       .border-3 {
         border-width: 3px;
       }
     `}</style>
    </div>
  );
}